import { getSmsFilePresignedUrl } from "../../../api/messages";
import { GET_FILE_PRESIGNED } from "@constants/reactQueryKeys";
import { error } from "logrocket";
import { useQuery } from "react-query";

/**
 * Fetches a presigned S3 URL for a given message Id.
 *
 * @param {string} messageId - The pkey key for the message.
 * @param {boolean} enabled - Optional bool to disable the query.
 * @param {number} [presignedExpirationMs=1800000] - Expiration time for the presigned URL in milliseconds (default: 30 minutes).
 */
const DEFAULT_EXPIRATION_MS = 30 * 60 * 1000;
export const useGetSMSFilePresignedUrl = (
  messageId,
  enabled = true,
  presignedExpirationMs = DEFAULT_EXPIRATION_MS
) => {
  const { data, isLoading, refetch, error } = useQuery(
    [GET_FILE_PRESIGNED, messageId],
    () => getSmsFilePresignedUrl(messageId),
    {
      enabled: !!messageId && enabled,
      staleTime: presignedExpirationMs,
      cacheTime: presignedExpirationMs + 2 * 60 * 1000,
      refetchInterval: presignedExpirationMs - 60 * 4000,
    }
  );

  return {
    presignedUrl: data?.data || null,
    urlLoading: isLoading,
    refetchUrl: refetch,
    presignedUrlErr: error,
  };
};
